import * as React from 'react';
import { AssignmentHistoryContainer } from '../../containers';

const AssignmentHistoryPage: React.FC = () => (
  <AssignmentHistoryContainer />
);

export default AssignmentHistoryPage;
